__turbopack_context__.v({
  "root": "ScrollToTop-module-scss-module__abeelW__root",
});
